import * as type from '../actions/types';
import { safeParse } from '../utils/helpers';

const initialState = {
  data: {},
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_CRM_GUEST_LIST_PENDING: {
      return {
        ...state,
        ...initialState,
        pending: true,
      };
    }

    case type.FETCH_CRM_GUEST_LIST_SUCCESS: {
      return {
        ...state,
        data: safeParse(action.payload.data),
        pending: false,
        success: true,
      };
    }

    case type.FETCH_CRM_GUEST_LIST_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
